import type { ColorValue } from './index';

/** A colour through the host's resolver, which tells a preset from a literal. */
export function colorValueVar(color: ColorValue | undefined, colorCss: (value: string) => string): string {
    return colorCss(color ?? '');
}
